import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import axios from 'axios';
import { t } from 'i18next';
import { MultiValue, ActionMeta } from 'react-select';

interface SelectProps {
  selectedTasks: number[];
  setSelectedTasks: (ids: number[]) => void;
}

interface UserOption {
  value: number;
  label: string;
}

const SelectUsers: React.FC<SelectProps> = ({ selectedTasks, setSelectedTasks }) => {
  const [users, setUsers] = useState<UserOption[]>([]);

  const handleSelectChange = (
    selectedOptions: MultiValue<UserOption>,
    _actionMeta: ActionMeta<UserOption>
  ) => {
    const ids = selectedOptions.map(opt => opt.value);
    setSelectedTasks(ids);
  };

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(`users`);
        const formattedUsers = data
        .sort((a: any, b: any) => a.first_name.localeCompare(b.first_name))
        .map((user: any) => ({
          value: user.id,
          label: `${user.first_name} ${user.last_name}`,
        }));
        setUsers(formattedUsers);
      } catch (e) {
        console.error('Failed to load users:', e);
      }
    })();
  }, []);

  const selectedOptions = users.filter(user => selectedTasks.includes(user.value));

  return (
    <Select
      isMulti
      isClearable
      name="users"
      closeMenuOnSelect={false}
      placeholder={t('Choose users')}
      value={selectedOptions}
      onChange={handleSelectChange}
      options={users}
      className="basic-multi-select w-full bg-[var(--bg-input)]"
      classNamePrefix="select"
    />
  );
};

export default SelectUsers;
